import React, { HTMLProps } from 'react';
import styles from './OrgBanner.module.scss';
import { ShadeBackground } from 'new/elements/ShadeBackground';
import { ProfileImage } from 'new/elements/ProfileImage';
import Typography from '@mui/material/Typography';
import { Org } from 'new/entities/Org';

interface OrgBannerProps {
  org: Org;
}

export function OrgBanner(props: OrgBannerProps & HTMLProps<HTMLDivElement>) {
  const { org, className, ...rest } = props;
  return (
    <div {...rest} className={[styles.container, className].join(' ')}>
      <ShadeBackground />
      <div className={styles.content}>
        <div className={styles.org_container}>
          <ProfileImage size="big" fullName={org.name} />
          <Typography variant="h2" className={styles.name}>
            {org.name}
          </Typography>
        </div>
      </div>
    </div>
  );
}
